import { cn } from '~/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-md bg-muted will-change-[background-position]',
        '[background-image:linear-gradient(105deg,transparent_0%_40%,var(--background)_50%,transparent_60%_100%)]',
        '[background-size:200%_auto] bg-no-repeat [background-position-x:-50%]',
        'motion-safe:animate-skeleton-shimmer',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
